import React from 'react';
import PropTypes from 'prop-types';
import VolumeBar from '../VolumeBar';
import Duration from './Duration';
import './style.scss';

export default function Controls({
    isVideo,
    isPlaying,
    volume,
    currentPosition,
    totalLength,
    onSeek,
    onPlayPause,
    onVolumeChange,
    toggleFullscreen
}) {
    return (
        <div className="controls">
            <div className="left">
                <button className={`play-button ${!isPlaying ? 'play' : 'pause'}`} onClick={onPlayPause}/>
                <Duration currentPosition={currentPosition} totalLength={totalLength}/>
                <VolumeBar volume={volume} handleVolumeChange={onVolumeChange}/>
            </div>
            <div className="right">
                <button className="seek-left" onClick={() => onSeek(-2)}>&#xAB;</button>
                <button className="seek-right" onClick={() => onSeek(2)}>&#xBB;</button>
                {isVideo && <button className="fullscreen" onClick={toggleFullscreen}/>}
            </div>
        </div>
    );
}

Controls.propTypes = {
    isVideo: PropTypes.bool.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    volume: PropTypes.number.isRequired,
    currentPosition: PropTypes.number.isRequired,
    totalLength: PropTypes.number.isRequired,
    onSeek: PropTypes.func.isRequired,
    onPlayPause: PropTypes.func.isRequired,
    onVolumeChange: PropTypes.func.isRequired,
    toggleFullscreen: PropTypes.func
};
